const toString = Object.prototype.toString;
const isArray = value => toString.call(value) === '[object Array]';
const isObject = value => value !== null && typeof value === 'object' && !isArray(value);
const isNonEmptyString = value => typeof value === 'string' && value.trim().length > 0;

class ErrorEventProperties {
  /**
   * Attempt to create event properties for the specified object
   * and the current context.
   *
   * Note: Ideally, this object should be an Error object, but
   * it could be anything (eg. null, undefined, etc).
   */
  static create(object) {
    const properties = {};

    // Contextual information.
    if (isNonEmptyString(location.pathname)) {
      properties.path = location.pathname;
    }
    if (isNonEmptyString(location.hash)) {
      properties.hash = location.hash;
    }
    if (isNonEmptyString(location.hostname)) {
      properties.hostname = location.hostname;
    }
    if (isNonEmptyString(location.search)) {
      properties.querystring = location.search;
    }
    if (isNonEmptyString(navigator.userAgent)) {
      properties.userAgent = navigator.userAgent;
    }

    // Object information.
    if (isObject(object)) {
      if (isNonEmptyString(object.message)) {
        properties.message = object.message;
      }
      if (isNonEmptyString(object.stack)) {
        properties.stack = object.stack;
      }
    } else {
      try {
        properties.message = String(object);
      } catch(e) {
        try {
          properties.message = toString.call(object);
        } catch(e) {
          // silence
        }
      }
    }
    return properties;
  }
}

module.exports = ErrorEventProperties;




// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/error-event-properties.js